<section class="grid gap-4">
  <div class="flex flex-wrap items-center justify-between gap-3">
    <div>
      <page-title [title]="'Create company'"></page-title>
    </div>
    <a mat-stroked-button routerLink="/companies">Back to list</a>
  </div>

  <company-form
    title="Create new company"
    submitLabel="Create"
    [busy]="companyStore.saving()"
    (submitted)="onSubmit($event)" />
</section>
